var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogOutVector({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2000,
    height: 2000,
    viewBox: "0 0 2000 2000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1336.12 397C1335 369.45 1341.16 312.053 1386.57 300C1389.93 326.402 1373.68 382.077 1336.12 397Z",
    fill: "#5061FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M558 473L1346 394",
    stroke: "black",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M993.198 315.768L1030 343.067C1030 347.859 1024.56 365.288 1021.83 373.403C1017.46 384.586 1008.18 396.982 996.842 405.342L1001.17 464H938.695V405.342C895.926 398.254 914.63 299.59 936.776 285L993.198 315.768Z",
    fill: "#FF9494"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M940.008 411H940V406.049C942.035 406.049 945.88 406.05 949.925 405.783C954.027 405.513 958.13 404.981 960.754 404L962 408.725C958.827 409.907 954.268 410.455 950.157 410.726C945.988 411 942.051 411 940.008 411Z",
    fill: "#2D2B38"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M889.357 280.13C868.088 308.707 930.328 353.884 954.427 333.197C985.946 306.137 988.784 347.052 988.784 347.052C998.788 335.025 1016.08 349.04 1010.96 365.268C1006.38 379.8 1023.03 401.102 1032.57 354.664C1057.17 354.664 1082.62 296.367 1030.82 277.461C1008.6 227.417 950.17 243.6 950.17 261.491C925.843 243.39 909.068 266.579 915.795 280.13C912.274 273.031 895.638 271.685 889.357 280.13Z",
    fill: "#2D2B38"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M865.777 1756.39L874.498 1636.13L768.71 1628.46L767.077 1650.98L652.194 1682.14L647.955 1740.59L735.953 1746.97L773.456 1749.69L801.349 1751.72L865.777 1756.39Z",
    fill: "#6372FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1209.1 1613.62L1139.04 1515.62L1052.65 1577.38L1065.77 1595.73L997.169 1693.15L1031.22 1740.79L1103.08 1689.41L1133.7 1667.52L1156.48 1651.24L1209.1 1613.62Z",
    fill: "#6372FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M712.923 1631.24L906.022 1650L879.537 1211.22L1012 839H748.022L668 1197.53L712.923 1631.24Z",
    fill: "#2D2B38"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M893.507 1551.64L897.043 1640.51C897.074 1641.16 896.805 1641.79 896.308 1642.23C895.82 1642.67 895.155 1642.87 894.503 1642.76L768.585 1622.94L769.267 1618.6L892.539 1638.01L889.101 1551.81L893.507 1551.64Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M1002.41 1619L1182 1488.5L1011.53 1235.34C1072.87 1080.51 1093.3 992.715 1100.55 834H865.737L795 1235.34L1002.41 1619Z",
    fill: "#2D2B38"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M643.219 521.194C625.478 489.312 618.037 458.017 645.68 453.447C686.853 446.64 702.909 457.327 693.585 483.934C688.045 459.684 699.989 445.096 707.672 453.447C720.753 467.665 712.15 504.039 697.967 509.88L643.219 521.194Z",
    fill: "#FF9494"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1087.7 1406.79L1142.92 1491.01C1143.36 1491.5 1143.55 1492.16 1143.44 1492.81C1143.33 1493.46 1142.94 1494.03 1142.37 1494.36L1034.73 1569.03L1032.53 1565.22L1137.85 1491.88L1084.38 1409.69L1087.7 1406.79Z",
    fill: "#FAFAFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M798.385 1236.16L833.167 1035.76L828.896 1035L794 1236.04L906.693 1448L911 1447.47L798.385 1236.16Z",
    fill: "#FAFAFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M624.41 520.974L724.24 502.477L759.425 586.947L870.328 476.659L928.37 574.435L822.815 667.268C785.587 707.519 690.876 701.262 662.335 629.194L624.41 520.974Z",
    fill: "#5061FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M748 839L1103 838.518L1081.27 532.432C1076.16 460.4 1081.27 439 913.016 439C879.624 439 858.705 480.642 848.85 514.04C836.851 554.698 819.797 610.674 805.001 652.544C778.401 727.816 748 839 748 839Z",
    fill: "#6372FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1088.38 768.416L1091.47 828.613C1091.49 829.092 1091.32 829.561 1091 829.911C1090.67 830.262 1090.21 830.466 1089.73 830.473L1022.9 831.633L1022.84 828.094L1087.84 826.965L1084.85 768.596L1088.38 768.416Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1031.41 610.21L1082.18 694.682L1078.96 696.032L1028.19 611.559L1031.41 610.21Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M931.471 472.557C971.436 429.522 1075.67 435.116 1112.41 480.841L1199.99 683.879C1221.24 742.932 1226.93 762.838 1127.02 786.836C1059.3 803.104 965.803 827.502 919.039 802.744C913.324 784.142 894.321 643.11 909.228 627.054L931.471 472.557Z",
    fill: "#6372FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1074.55 790.568C1044.07 810.62 981.387 838.893 964.399 818.666C944.718 795.229 970.839 745.178 998.062 752.507C988.611 747.972 972.959 738.861 981.234 731.454C997.845 716.583 1052.34 723.095 1059.22 736.807L1074.55 790.568Z",
    fill: "#FF9494"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1077.73 588.005L1113.96 671.592C1113.99 672.07 1113.81 672.539 1113.49 672.889C1113.16 673.24 1112.7 673.444 1112.23 673.451L1056.77 688.261L1056.71 684.721L1110.33 669.943L1074.2 588.185L1077.73 588.005Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1336 397C1336 370.019 1325.81 321.452 1276 304C1276 329.833 1292.53 385.059 1336 397Z",
    fill: "#6372FF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1336.23 394C1313.06 429.903 1233.37 681.795 1381.44 655.01C1529.52 628.226 1362.79 423.634 1336.23 394Z",
    fill: "#6372FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOutVector);
export default __webpack_public_path__ + "static/media/log-out-vector.52871b6c526149812122c291ef9578cf.svg";
export { ForwardRef as ReactComponent };